import { connect } from 'react-redux';
import { List } from 'immutable';

import PartnershipTagRecipientForm from '../components/PartnershipTagRecipientForm';
import {
  loadPartnershipTagRecipient,
  updatePartnershipTagRecipient,
} from '../../../../../state/modules/partnershipTagsRecipients/actions';

const inputs = List([
  'recipients',
  'partnership_tags_recipients_care_guide_partner_tags',
  'partnership_tags_recipients_admin_partner_classes',
  'partnership',
  'is_enabled',
]);

const mapStateToProps = (state) => {
  const id = state.partnershipTagsRecipients.get('id');
  const data = {},
    errors = {};
  for (const val of inputs.values()) {
    data[val] = state.entities.getIn(
      ['partnershipTagsRecipients', id, val],
      ''
    );
    errors[val] = state.partnershipTagsRecipients.getIn([
      'form',
      'errors',
      val,
    ]);
  }
  data['partnership_tags_recipients_care_guide_partner_tags'] =
    data['partnership_tags_recipients_care_guide_partner_tags'] !== ''
      ? data['partnership_tags_recipients_care_guide_partner_tags']
      : [];
  data['partnership_tags_recipients_admin_partner_classes'] =
    data['partnership_tags_recipients_admin_partner_classes'] !== ''
      ? data['partnership_tags_recipients_admin_partner_classes']
      : [];
  data['recipients'] = data['recipients'] ?? [];
  data['is_enabled'] = data['is_enabled'] ?? false;

  return {
    id: id ?? null,
    data: data,
    errors: errors,
    isLoading: state.partnershipTagsRecipients.get('isLoading'),
    isSubmitting: state.partnershipTagsRecipients.get('isSubmitting'),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    load: (cb) => {
      dispatch(loadPartnershipTagRecipient(cb));
    },
    update: (id, data, cb) => {
      dispatch(updatePartnershipTagRecipient(id, data, cb));
    },
  };
};

const PartnershipTagRecipientFormContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(PartnershipTagRecipientForm);

export default PartnershipTagRecipientFormContainer;
